import axios from "axios";
import { baseUrl } from "../../common/config";
import { http } from "../../common/helpers/http";
import type { ApiResponse, ParticipantLogin } from "../../models/api";

export const loginService = ({ username, password }) =>
  axios<ApiResponse<ParticipantLogin>>(
    `${baseUrl}/api/auth/participant/login`,
    {
      method: "POST",
      data: { userName: username, password },
    }
  );

export const loginToken = ({ accessToken, refreshToken }) =>
  axios<ApiResponse<ParticipantLogin>>(
    `${baseUrl}/api/auth/participant/login-token`,
    {
      method: "POST",
      data: { accessToken, refreshToken },
    }
  );

export const forgotPasswordService = async ({ email }) => {
  try {
    const response = await http({
      url: `${baseUrl}/api/auth/participant/password-recovery?username=${email}`,
      method: "POST",
    });
    return response;
  } catch (e) {
    return e;
  }
};

export const validateResetPasswordService = async ({ id }) => {
  try {
    const response = await http({
      url: `${baseUrl}/api/auth/participant/password-recovery/validate?id=${id}`,
      method: "POST",
    });

    return response;
  } catch (e) {
    return e;
  }
};

export const resetPasswordService = async ({
  id,
  password,
  confirmPassword,
}) => {
  try {
    const response = await http({
      url: `${baseUrl}/api/auth/participant/password-recovery`,
      method: "PUT",
      data: {
        id,
        password,
        confirmPassword,
      },
    });

    return response;
  } catch (e) {
    return e.response;
  }
};

export const validateCreatePasswordService = async ({ id }) => {
  try {
    const response = await http({
      url: `${baseUrl}/api/auth/participant/password/completed?id=${id}`,
      method: "GET",
    });
    return response;
  } catch (e) {
    return e;
  }
};

export const createPasswordService = async ({
  participantProfileId,
  password,
  confirmPassword,
}) => {
  try {
    const response = await http({
      url: `${baseUrl}/api/auth/participant/password`,
      method: "POST",
      data: {
        participantProfileId,
        password,
        confirmPassword,
      },
    });

    return response;
  } catch (e) {
    return e.response;
  }
};

export const retakeAssessmentService = async ({ id }) => {
  try {
    const response = await http({
      url: `${baseUrl}/api/assessments/restart?userProfileId=${id}`,
      method: "POST",
    });

    return response;
  } catch (e) {
    return e;
  }
};

export const changePasswordService = async ({
  currentPassword,
  password,
  confirmPassword,
}) => {
  try {
    const response = await http({
      url: `${baseUrl}/api/auth/participant/change-password`,
      method: "PUT",
      data: {
        currentPassword,
        password,
        confirmPassword,
      },
    });

    return response;
  } catch (e) {
    return e.response;
  }
};

export const sendWelcomeEmail = (email) =>
  http.post(`${baseUrl}/api/participant-notification/welcome`, { email });

export const validateEmailCode = (email, participantKey) =>
  http.post(`${baseUrl}/api/participant/validate-key`, {
    email,
    participantKey,
  });

export const sendValidateCodeEmail = (email) => {
  return http.post(`${baseUrl}/api/participant-notification/participant-key`, {
    email,
  });
};

export const validateUpdatePrimaryEmailParticipantService = ({ id }) =>
  http.post(
    `${baseUrl}/api/auth/participant/update-primary-email-request/validate?id=${id}`
  );
